import { render } from "./Gtm.vue?vue&type=template&id=8688c246"
import script from "./Gtm.vue?vue&type=script&lang=js"
export * from "./Gtm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/website/interhides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/cookie/analytic/Gtm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8688c246"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8688c246', __exports__)) {
    api.reload('8688c246', __exports__)
  }
  
  module.hot.accept("./Gtm.vue?vue&type=template&id=8688c246", () => {
    api.rerender('8688c246', render)
  })

}


export default __exports__